class VariantPopup extends HTMLElement{
  constructor(){
    super();
    this.externalFxns();
  }
  externalFxns(){
    if(this.querySelector('.variant-popup__overlay')){ document.getElementById('SortPopOverflowMist').addEventListener('click',(evt)=> this.popupClose()); }
    if(this.querySelector('[jsVariantPopClose]')){ this.querySelector('[jsVariantPopClose]').addEventListener('click',(evt)=> this.popupClose()); }
    if(this.parentElement.querySelector('[jsVariantAddCTA][MultiVariantAvailable="true"]')){
      this.parentElement.querySelector('[jsVariantAddCTA][MultiVariantAvailable="true"]').addEventListener('click',this.popupOpen.bind(this)); 
    }
    if(this.querySelector('[jsVariantPopCloseAfterSelect]')){ this.querySelector('[jsVariantPopCloseAfterSelect]').addEventListener('click',this.bundleFormation.bind(this)); }
    const variantCheck = this.querySelectorAll('[jsCheckItEnable]');
    for(let i=0; i<variantCheck.length; i++){if(variantCheck[i]){variantCheck[i].addEventListener('click',this.variantChange.bind(variantCheck[i]))}}
  }
  popupOpen(event){
    if(event.target.getAttribute('type') == 'checkbox' && !event.target.hasAttribute('checked') && event.target.hasAttribute('MultiVariantAvailable')){
      // event.target.offsetParent.offsetParent.offsetParent.parentElement.querySelector('variant-popup').classList.add('pop_the_variant');
      event.target.closest('.JPS_SPCard-Main').querySelector('variant-popup').classList.add('pop_the_variant');
      event.target.setAttribute('checked','checked');
      event.target.checked = true;
      document.body.classList.add('variant_popup_active');
    }else if(event.target.getAttribute('type') == 'checkbox' && event.target.hasAttribute('checked') && event.target.hasAttribute('MultiVariantAvailable')){
      this.querySelector('no-variant-popup [jsVariantAddCTA]').value = '';
      event.target.removeAttribute('checked');
      event.target.checked = false;
    }else{
      // event.target.offsetParent.parentElement.querySelector('variant-popup').classList.add('pop_the_variant')
      event.target.closest('.JPS_SPCard-Main').querySelector('variant-popup').classList.add('pop_the_variant');
      document.body.classList.add('variant_popup_active');
    }
  }
  popupClose(event){
    if(this.parentElement.querySelector('no-variant-popup [jsVariantAddCTA]') && !this.parentElement.querySelector('no-variant-popup [jsVariantAddCTA]').hasAttribute('jsvariantpopcloseafterselect')){
      this.parentElement.querySelector('no-variant-popup [jsVariantAddCTA]').checked = false
      this.parentElement.querySelector('no-variant-popup [jsVariantAddCTA]').removeAttribute('checked');
    }
    this.classList.remove('pop_the_variant');
    document.body.classList.remove('variant_popup_active');
  }
  variantChange(event){
    event.preventDefault();
    this.classList.add('current_option'); 
    var node = this.parentNode.firstChild, vID = this.querySelector('[jsCheckToggler]').value, 
        vPRICE = this.querySelector('[jsCheckToggler]').getAttribute('price'), vCMP = this.querySelector('[jsCheckToggler]').getAttribute('cmp'), vDiscount = this.querySelector('[jsCheckToggler]').getAttribute('discount');
    this.querySelector('[jsCheckToggler]').checked = true; this.querySelector('[jsCheckToggler]').setAttribute('checked','checked');
    while(node){ if(node !== this && node.nodeType === Node.ELEMENT_NODE ) node.classList.remove('current_option'), node.querySelector('[jsCheckToggler]').checked = false,node.querySelector('[jsCheckToggler]').removeAttribute('checked');
                node = node.nextElementSibling || node.nextSibling; }
    if(this.parentNode.parentNode.querySelector('.product-variant-id')){
      this.parentNode.parentNode.querySelector('.product-variant-id').value = vID;
      this.parentNode.parentNode.querySelector('.product-variant-id').setAttribute('price',vPRICE);
    }
    if(this.parentNode.parentNode.querySelector('[jsVariantAddCTA]')){
      this.parentNode.parentNode.querySelector('[jsVariantAddCTA]').value = vID;
      this.parentNode.parentNode.querySelector('[jsVariantAddCTA]').setAttribute('price',vPRICE);
      this.parentNode.parentNode.querySelector('[jsVariantAddCTA]').setAttribute('cmp',vCMP);
      this.parentNode.parentNode.querySelector('[jsVariantAddCTA]').setAttribute('discount',vDiscount);
    }
  }
  bundleFormation(event){
    var CURRENCY = document.body.getAttribute('currency'), vPRICE = event.target.getAttribute('price'), vCMP = event.target.getAttribute('cmp'), vDiscount = event.target.getAttribute('discount');
    if(!this.parentElement.querySelector('no-variant-popup [jsVariantAddCTA]').hasAttribute('jsvariantpopcloseafterselect')){
      this.parentElement.querySelector('no-variant-popup [jsVariantAddCTA]').value = event.target.value;
      this.parentElement.querySelector('no-variant-popup [jsVariantAddCTA]').setAttribute('price',vPRICE);
      this.parentElement.querySelector('.SPCard-offerPrice').innerHTML = CURRENCY+vPRICE;
      if(this.parentElement.querySelector('.SPCard-CMP')){
         this.parentElement.querySelector('.SPCard-CMP').innerHTML = vCMP;
      }
       if(this.parentElement.querySelector('.SPCard-Discount')){
      this.parentElement.querySelector('.SPCard-Discount').innerHTML = vDiscount;
       }
    }
    this.classList.remove('pop_the_variant');
    document.body.classList.remove('variant_popup_active');
  }
}
customElements.define('variant-popup', VariantPopup)

class NoPopupExists extends HTMLElement{
  constructor(){
    super();
    this.externalFxns();
  }
  externalFxns(){
    this.querySelectorAll('.jPS_SPCMedBGColor [type="checkbox"]').forEach(function(e){
      e.checked = false;
      e.removeAttribute('checked','checked');
    })
    let checkedVariantID = [], checkedVariantPrice = 0;
    const variantCheck = this.querySelectorAll('no-variant-popup [jsVariantAddCTA]');
    for(let i=0; i<variantCheck.length; i++){
      if(variantCheck[i]){
        variantCheck[i].addEventListener('click',function(evt){
          let ID = evt.target.value, PRICE = parseFloat(evt.target.getAttribute('price')), CURRENCY = document.body.getAttribute('currency');
          if(evt.target.checked == true && event.target.hasAttribute('singleVariantOpt')){
            evt.target.setAttribute('checked','checked');
            checkedVariantID.push(ID); checkedVariantPrice = checkedVariantPrice + PRICE;
          }else if(evt.target.checked == false && !event.target.hasAttribute('singleVariantOpt')){
            const index = checkedVariantID.indexOf(ID);
            if (index > -1){ checkedVariantID.splice(index, 1); }
            if(checkedVariantPrice >= PRICE){ checkedVariantPrice = checkedVariantPrice - PRICE; }
            else{ checkedVariantPrice = PRICE - checkedVariantPrice; }
            
          }else if(evt.target.checked == false && event.target.hasAttribute('singleVariantOpt')){
            const index = checkedVariantID.indexOf(ID);
            evt.target.removeAttribute('checked');
            if (index > -1){ checkedVariantID.splice(index, 1); }
            if(checkedVariantPrice >= PRICE){ checkedVariantPrice = checkedVariantPrice - PRICE; }
            else{ checkedVariantPrice = PRICE - checkedVariantPrice; }
          }
          if(evt.target.nodeName == 'BUTTON'){
            checkedVariantID.push(ID); checkedVariantPrice = checkedVariantPrice + PRICE;
          }
          var joinedVariant = checkedVariantID.join(','), ArrayLength = checkedVariantID.length, FinalPrice = CURRENCY+checkedVariantPrice, 
              AddONText = 'Add all '+parseInt(ArrayLength+1)+' items to Cart', NoAddONText = 'Add 1 item to the Cart';
          let MainPrice = parseFloat(document.querySelector('.TotalItemSum').getAttribute('price'));
          if(ArrayLength > 0){
            document.querySelector('.bundle-form__submit span').innerHTML = AddONText
          }else{
            document.querySelector('.bundle-form__submit span').innerHTML = NoAddONText
          }
          document.querySelector('.TotalItemSum').innerHTML = CURRENCY+parseFloat(MainPrice + checkedVariantPrice)
          document.querySelector('.addOnNOC').innerHTML = ArrayLength;
          document.querySelector('.AddONItemSum').innerHTML = FinalPrice;
          document.querySelector('bundle-form').setAttribute('bundleArray',checkedVariantID);
        })
      }
    }
  }
}
customElements.define('no-popup-exists', NoPopupExists)